import React from 'react'

import { Text } from '@wartek-id/text'

import { FAQ1, FAQ2, FAQ3, FAQ4, FAQ5 } from './FAQ'

const FAQS = [FAQ1, FAQ2, FAQ3, FAQ4, FAQ5]

const FAQSection = () => {
  const [activeFAQIndex, setActiveFAQIndex] = React.useState<number | null>(
    null
  )
  return (
    <div className="px-4 py-6" id="faq-section">
      <Text color="inverse" variant="heading-md" className="mb-4">
        Pertanyaan Seputar Asesmen
      </Text>
      <div className="bg-white">
        {FAQS.map((faq, index) =>
          React.createElement(faq, {
            open: activeFAQIndex === index,
            onToggle: () => {
              setActiveFAQIndex(activeFAQIndex === index ? null : index)
            },
          })
        )}
      </div>
    </div>
  )
}

export default FAQSection
